// ---- SUPPORT STORAGE METHODS ---- //
export enum StorageMethod {
    SET = "SET",
    GET = "GET",
    REMOVE = "REMOVE",
    KEYS = "keys",
    WIPE = "wipe",
    SEC_SET = "SEC_SET",
    SEC_GET = "SEC_GET"
}